import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { usePDFContent } from './PDF.js';
import { styled } from 'styled-components';
import { Spinner } from '@fabric-app/ui/components/Spinner';

const Placeholder = styled.div.withConfig({
  displayName: "PagePlaceholder__Placeholder",
  componentId: "sc-171097ff-0"
})([
  `background:#e6e6e6;width:100%;height:100%;&[data-absolute='true']{position:absolute;inset:0;}display:flex;justify-content:center;align-items:center;background-size:cover;background-position:center;background-repeat:no-repeat;background-clip:content-box;`
]);
const PagePlaceholder = ({ pageNumber, absolute, smallSpinner = false }) => {
  const { getPagePlaceholderImage } = usePDFContent();
  const image = useMemo(() => {
    const image2 = getPagePlaceholderImage(pageNumber);
    if (!image2) return null;
    return image2.normal;
  }, [
    getPagePlaceholderImage,
    pageNumber
  ]);
  return /* @__PURE__ */ jsx(Placeholder, {
    "data-absolute": !!absolute,
    style: image ? {
      backgroundImage: `url(${image})`
    } : {},
    children: !image && /* @__PURE__ */ jsx(Spinner, {
      size: smallSpinner ? 15 : 30,
      thickness: 3
    })
  });
};

export { PagePlaceholder as default };
//# sourceMappingURL=PagePlaceholder.js.map
